export default __webpack_public_path__ + "fonts/notifications-empty-state.svg";